import {
  StyledSessionList
} from '../VsBattlePopup/VsBattlePopup.styled';
import { useShopItems, useTokenAuth } from '../../hooks';
import { AppContext } from '../../providers/AppContext';
import { getBackgroundFromItem } from '../../utils';
import { useAudio } from '../../providers/AudioContext';
import { getCheckoutSession } from '../../providers/BasejumpApiProvider';
import {
  ShopHeader,
  ShopWrapper,
  ShopContent,
  StyledShopTitle,
  ShopTitleMain,
  ShopTitleSecondary,
  StyledShopSection,
  StyledShopSectionObjects,
  ShopSectionObjectsRow,
  StyledShopCategory,
  ShopCategoryImageWrapper,
  ShopCategoryImageHolder,
  ShopCategoryName,
  ShopCategoryImageName,
  ShopCategoryBg,
  ShopItemLabel,
  ShopItemPriceLabel,
  ShopItemName,
  ShopItemMeta,
  ShopItemInfo,
  ShopItemBuy,
  ShopItemBuyHolder,
  ShopItemRarity,
  DisabledShade
} from './ShopPopup.styled';
import { BroadsiderHudPopup } from '../';
import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderButton,
  PopupHeaderButtonSeparator,
  PopupHeaderTitle,
  PopupHeader
} from '../PopupHeader/PopupHeader.styled';
import { theme } from '../../theme';
import { useContext, useState } from 'react';
import { DiscordSdkContext } from '../../providers/DiscordSdkProvider';
const HEADER_ID = 'shop_header';

const ShopCategory = ({ category }) => {
  const [hovered, setHovered] = useState(false);
  const onMouseEnter = () => {
    playSFX('hover');
    setHovered(true);
  };
  const onMouseLeave = () => {
    setHovered(false);
  };

  const { playSFX } = useAudio();

  const onSelectCategory = () => {
    playSFX('menu_button');
    document.getElementById(category.id).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <StyledShopCategory onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onSelectCategory}>
      <ShopCategoryImageWrapper $hovered={hovered}>
        <ShopCategoryImageHolder style={{ background: category.background }}>
          <ShopCategoryImageName>{category.name}</ShopCategoryImageName>
          <ShopCategoryBg src='/assets/item_bg.png'/>
          <ShopCategoryBg src={category.imageUrl} $hovered={hovered}/>
        </ShopCategoryImageHolder>
      </ShopCategoryImageWrapper>
      <ShopCategoryName $hovered={hovered}>{category.name}</ShopCategoryName>
    </StyledShopCategory>
  );
};

const ShopSku = ({ sku }) => {
  const { isDiscord, buySku } = useContext(DiscordSdkContext);
  const [hovered, setHovered] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const onMouseEnter = () => {
    playSFX('hover');
    setHovered(true);
  };
  const onMouseLeave = () => {
    setHovered(false);
  };

  const { playSFX } = useAudio();
  const { basejumpToken } = useTokenAuth();
  const { setErrorData } = useContext(AppContext);

  const priceTag = `$${(sku.price / 100).toFixed(2)}`;

  const onSelect = async () => {
    playSFX('button');
    try {
      setDisabled(true);
      if (isDiscord) {
        await buySku(sku.discord_sku_id);
      } else {
        const checkoutSession = await getCheckoutSession(basejumpToken, sku.id);
        const checkoutUrl = checkoutSession.url;
        window.open(checkoutUrl.toString(), '_blank', 'width=400,height=600');
      }
    } catch (err) {
      setErrorData({ title: 'Error', description: 'We were not able to place your order!'});
    } finally {
      setDisabled(false);
    }
  };

  return (
    <StyledShopCategory onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={() => disabled ? false : onSelect()}>
      <ShopCategoryImageWrapper $hovered={hovered}>
        <ShopCategoryImageHolder>
          <ShopCategoryBg $hovered={hovered} src={sku.image_url}/>
          <ShopItemPriceLabel style={{ background: theme.background, color: 'white' }}>{priceTag}</ShopItemPriceLabel>
	  {disabled && <DisabledShade />}
        </ShopCategoryImageHolder>
      </ShopCategoryImageWrapper>
      <ShopItemInfo>
        <ShopItemName $hovered={hovered}>{sku.name}</ShopItemName>
        <ShopItemBuyHolder>
          {hovered && <ShopItemBuy>BUY</ShopItemBuy>}
        </ShopItemBuyHolder>
      </ShopItemInfo>
    </StyledShopCategory>
  );
};
const ShopItem = ({ asset }) => {
  const { setSelectedShopAsset } = useContext(AppContext);
  const [hovered, setHovered] = useState(false);
  const onMouseEnter = () => {
    playSFX('hover');
    setHovered(true);
  };
  const onMouseLeave = () => {
    setHovered(false);
  };

  const addAlpha = (colorCode) => {
    return colorCode + 'CC';
  };

  const { playSFX } = useAudio();

  const background = getBackgroundFromItem(asset);
  const price = asset.getPrice().pricePoints >= 0 ? `${asset.getPrice().pricePoints}` : 'N/A';

  const onSelect = () => {
    playSFX('button');
    setSelectedShopAsset(asset);
  };

  return (
    <StyledShopCategory onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onSelect}>
      <ShopCategoryImageWrapper $hovered={hovered}>
        <ShopCategoryImageHolder style={{ background: asset.isLocked() ? 'gray' : addAlpha(background) }}>
          <ShopCategoryBg src='/assets/item_bg.png' style={asset.isLocked() ? { filter: 'grayscale(1)'} : {}}/>
          <ShopCategoryBg src={asset.getImgSource()} $hovered={hovered} style={asset.isLocked() ? { filter: 'grayscale(1)'} : {}}/>
          <ShopItemLabel style={{ background }}>{asset.getType()}</ShopItemLabel>
          <ShopItemPriceLabel style={{ background }}><span>{price}</span><img style={{width: '1rem' }} src='/assets/coin_low.gif'/></ShopItemPriceLabel>
        </ShopCategoryImageHolder>
      </ShopCategoryImageWrapper>
      <ShopItemInfo>
        <ShopItemMeta>
          <ShopItemRarity $hovered={hovered}>{asset.getRarity()}</ShopItemRarity>
        </ShopItemMeta>
        <ShopItemName $hovered={hovered}>{asset.getName()}</ShopItemName>
        <ShopItemBuyHolder>
          {hovered && <ShopItemBuy>{asset.isLocked() ? 'LOCKED' : 'BUY'}</ShopItemBuy>}
        </ShopItemBuyHolder>
      </ShopItemInfo>
    </StyledShopCategory>
  );
};

const ShopSectionObjects = ({ children }) => {
  const itemsPerRow = 3;
  const groupSize = 3;
  const itemGroups = children.reduce(function(result, value, index, array) {
    if (index % groupSize === 0)
      result.push(array.slice(index, index + groupSize));
    return result;
  }, []);
  return (
    <StyledShopSectionObjects>
      {itemGroups.map((g) => <ShopSectionObjectsRow>{g}</ShopSectionObjectsRow>)}    
    </StyledShopSectionObjects>
  );
};

const ShopTitle = () => {
  return (
    <StyledShopTitle id={HEADER_ID}>
      <ShopTitleMain>Shop</ShopTitleMain>
      <ShopTitleSecondary>Each <span className='shop-title-bold'>Item</span> purchased protects a real world area of rainforest - help us protect over <span className='shop-title-gold shop-title-bold'>4MM acres</span></ShopTitleSecondary>
    </StyledShopTitle>
  )
};

const ShopSectionTitle = ({ children, hasBackButton = false, background = null }) => {
  const onClickBack = () => {
    document.getElementById(HEADER_ID).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <PopupHeader>
      <PopupHeaderStart $background={background}/>
      {hasBackButton && <PopupHeaderButton $background={background} onClick={onClickBack}>
        <img src='/assets/arrow_right.svg' style={{ rotate: '-90deg' }}/>
      </PopupHeaderButton>}
      {hasBackButton && <PopupHeaderButtonSeparator $background={background} />}
      <PopupHeaderTitle>
        {children}
      </PopupHeaderTitle>
      <PopupHeaderEnd $background={background} />
    </PopupHeader>
  );
};

const ShopSection = ({ title, id, children, hasBackButton = false, background = null }) => {
  return (
    <StyledShopSection id={id}>
      <ShopSectionTitle hasBackButton={hasBackButton} background={background}>{title}</ShopSectionTitle>
      <ShopSectionObjects>
        {children}
      </ShopSectionObjects>
    </StyledShopSection>
  )
}

const ShopPopup = () => {
  const { basejumpToken } = useTokenAuth();
  const { items, skus } = useShopItems();
  const categories = [
    { id: 'bone_packs', name: 'BONES Packs', background: theme.background, imageUrl: '/assets/sku/pack50.png', items: skus, isSku: true },
    { id: 'section_weapon', name: 'Weapon', background: theme.baseRed, imageUrl: '/assets/category_weapon.gif', filter: (a) => a.getType() === 'weapon' },
    { id: 'section_food', name: 'Food\u00A0& Drink', background: theme.baseGreen, imageUrl: '/assets/category_food.gif', filter: (a) => a.getType() === 'object' && a.getEffects().includes('FOOD')},
    { id: 'section_armour', name: 'Armour', background: theme.baseOrange, imageUrl: '/assets/category_armour.gif', filter: (a) => a.getType() === 'armor' },
    { id: 'section_misc', name: 'Misc', background: theme.basePurple, imageUrl: '/assets/category_misc.gif', filter: (a) => a.getType() === 'object' && !a.getEffects().includes('FOOD')}
  ];

  categories.forEach((c) => {
    if (c.filter) {
      c.items = items.filter(c.filter);
    }
  });

  const categoriesToRender = categories.filter(c => c.items.length > 0);
  return (
    <BroadsiderHudPopup>
      <StyledSessionList>
        <ShopWrapper>
          <ShopContent>
            <ShopHeader>
              <ShopTitle/>
              <img src='/assets/peru.png' />
            </ShopHeader>
            <ShopSection title='Object Categories'>
              {categoriesToRender.map(c => (<ShopCategory category={c}/>))}
            </ShopSection>
	    {categoriesToRender.map(c => {
              return (
                <ShopSection background={c.background} hasBackButton={true} title={c.name} id={c.id}>
                  {c.items.map(a => c.isSku ? (<ShopSku sku={a}/>) : (<ShopItem asset={a}/>))}
                </ShopSection>
              );
	    })}
          </ShopContent>
        </ShopWrapper>
      </StyledSessionList>
    </BroadsiderHudPopup>
  );
};

export default ShopPopup;
